var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c(
      "form",
      {
        staticClass: "justify-content-center",
        attrs: { id: "client-profile-details-form" },
        on: {
          change: _vm.updateProfileDetails,
          submit: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "col-12 m-0 form-page p-0",
            attrs: { id: "personal-details-container" },
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6 pr-2" },
                [
                  _c("material-input", {
                    attrs: {
                      label: _vm.$t("account.givenName"),
                      "required-indicator": "",
                    },
                    model: {
                      value: _vm.profileDetails.givenName,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileDetails, "givenName", $$v)
                      },
                      expression: "profileDetails.givenName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 pl-2" },
                [
                  _c("material-input", {
                    attrs: { label: _vm.$t("account.familyName") },
                    model: {
                      value: _vm.profileDetails.familyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileDetails, "familyName", $$v)
                      },
                      expression: "profileDetails.familyName",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("material-input", {
                    ref: "profileDetailsEmailMaterialInput",
                    attrs: { label: _vm.$t("account.email"), type: "email" },
                    model: {
                      value: _vm.profileDetails.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileDetails, "email", $$v)
                      },
                      expression: "profileDetails.email",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "material-input",
                    { attrs: { label: _vm.$t("account.phoneNumber") } },
                    [
                      _c("phone-input", {
                        staticClass: "material-input form-control form",
                        attrs: {
                          id: "phone-number-label",
                          name: "phoneNoFill",
                          pattern: ".{14,14}",
                          title: "Please, enter a valid phone number",
                          type: "text",
                          "data-lpignore": "true",
                          "emit-value": true,
                          value: _vm.profileDetails.phoneNumber,
                        },
                        on: {
                          change: function (val) {
                            return (_vm.profileDetails.phoneNumber = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "material-input",
                    {
                      staticClass: "position-relative fe-dp",
                      attrs: { label: _vm.$t("account.birthDate") },
                      model: {
                        value: _vm.profileDetails.dateOfBirth,
                        callback: function ($$v) {
                          _vm.$set(_vm.profileDetails, "dateOfBirth", $$v)
                        },
                        expression: "profileDetails.dateOfBirth",
                      },
                    },
                    [
                      _c("datepicker-input", {
                        attrs: {
                          id: "date-of-birth-label",
                          name: "date-of-birth",
                          placeholder: _vm.$t("account.birthDate"),
                          autocomplete: "off",
                          "past-date": "",
                        },
                        model: {
                          value: _vm.profileDetails.dateOfBirth,
                          callback: function ($$v) {
                            _vm.$set(_vm.profileDetails, "dateOfBirth", $$v)
                          },
                          expression: "profileDetails.dateOfBirth",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 pr-0" }, [
                _c("div", { staticClass: "mb-3 inline-actions no-border" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "h6",
                        { staticClass: "font-xs text-light-gray mb-0" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("global.actions.searchReferrers")) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        { attrs: { "no-label": "" } },
                        [
                          _c("referrers-select", {
                            staticClass: "simple-dd referrerSelect",
                            attrs: {
                              "allow-create": false,
                              "has-checkboxes": false,
                              "space-classes": "col-12 pl-0",
                              value: _vm.referrerSelected,
                              "allow-clear": "",
                            },
                            on: { change: _vm.changeReferrer },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "material-input",
                    {
                      attrs: {
                        label: _vm.$t("global.words.value"),
                        "label-for": "value-label",
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.profileDetails.value,
                            expression: "profileDetails.value",
                          },
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: _vm.mask,
                            expression: "mask",
                          },
                        ],
                        staticClass:
                          "material-input form-control form form-control-filled",
                        attrs: {
                          id: "value-label",
                          "data-lpignore": "true",
                          placeholder: "0",
                          type: "text",
                        },
                        domProps: { value: _vm.profileDetails.value },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.profileDetails,
                              "value",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }